module.exports = __webpack_public_path__ + "static/media/atlantic-halibut.d302c88f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/atlantic-halibut.png
// module id = 295
// module chunks = 0